import { contemTextoPesquisa } from "../Utils/pesquisaTexto";
import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  collection,
  getDocs,
  orderBy,
  query,
} from "firebase/firestore";
import { useHistory } from "react-router-dom";
import Navbar from "../Components/Navbar/navbar";
import { db } from "../Config/firebase";
import { consultaTenantAtual } from "../Utils/tenant";

const COLLECTION = "tblGestaoMudancas";

function formatarDataBR(data) {
  if (!data) return "-";
  const [ano, mes, dia] = String(data).split("-");
  return ano && mes && dia ? `${dia}/${mes}/${ano}` : String(data);
}

export default function CadastroGestaoMudancas() {
  const history = useHistory();
  const [registros, setRegistros] = useState([]);
  const [filtro, setFiltro] = useState("");
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    carregarRegistros();
  }, []);

  async function carregarRegistros() {
    setCarregando(true);
    try {
      const snap = await getDocs(
        consultaTenantAtual(
          query(collection(db, COLLECTION), orderBy("criadoEm", "desc"))
        )
      );
      setRegistros(snap.docs.map((item) => ({ id: item.id, ...item.data() })));
    } finally {
      setCarregando(false);
    }
  }

  const registrosFiltrados = useMemo(() => {
    const termo = filtro.trim().toLocaleLowerCase("pt-BR");
    if (!termo) return registros;

    return registros.filter((registro) =>
      [
        registro.codigo,
        registro.solicitante,
        registro.areaImpactada,
        registro.descricaoMudanca,
        registro.statusImplementacao,
      ].some((valor) =>
        contemTextoPesquisa(String(valor || "").toLocaleLowerCase("pt-BR"), termo)
      )
    );
  }, [filtro, registros]);

  return (
    <>
      <Navbar />
      <Box sx={{ p: { xs: 2, md: 4 } }}>
        <Paper
          elevation={0}
          sx={{
            border: "1px solid #e2e8f0",
            borderRadius: 2,
            mb: 2,
            p: 2,
          }}
        >
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            spacing={2}
          >
            <Box>
              <Typography variant="h5" fontWeight={700}>
                Gestão de Mudanças
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Registros de avaliação, aprovação, implantação e eficácia das mudanças.
              </Typography>
            </Box>
            <Button
              variant="contained"
              onClick={() => history.push("/app/gestao-mudancas/novo")}
            >
              Novo registro
            </Button>
          </Stack>
          <TextField
            label="Pesquisar registro"
            value={filtro}
            onChange={(event) => setFiltro(event.target.value)}
            size="small"
            fullWidth
            sx={{ mt: 2 }}
          />
        </Paper>

        <Paper sx={{ border: "1px solid #e2e8f0", overflow: "auto" }}>
          <Table size="small" sx={{ minWidth: 900 }}>
            <TableHead sx={{ backgroundColor: "#f8fafc" }}>
              <TableRow>
                <TableCell>Código</TableCell>
                <TableCell>Solicitação</TableCell>
                <TableCell>Solicitante</TableCell>
                <TableCell>Área impactada</TableCell>
                <TableCell>Status</TableCell>
                <TableCell align="center">Ações</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {registrosFiltrados.map((registro) => (
                <TableRow
                  key={registro.id}
                  hover
                  onClick={() =>
                    history.push(`/app/gestao-mudancas/${registro.id}`)
                  }
                  sx={{ cursor: "pointer" }}
                >
                  <TableCell sx={{ whiteSpace: "nowrap" }}>{registro.codigo || "-"}</TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>
                    {formatarDataBR(registro.dataSolicitacao)}
                  </TableCell>
                  <TableCell>{registro.solicitante || "-"}</TableCell>
                  <TableCell>{registro.areaImpactada || "-"}</TableCell>
                  <TableCell>
                    <Typography
                      variant="body2"
                      color={registro.aprovadoDirecao === true ? "success.main" : "text.primary"}
                    >
                      {registro.aprovadoDirecao === true
                        ? "Aprovado"
                        : registro.statusImplementacao || "-"}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Tooltip title="Visualizar relatório">
                      <IconButton
                        size="small"
                        onClick={(event) => {
                          event.stopPropagation();
                          history.push(`/app/gestao-mudancas/${registro.id}?print=1`)
                        }}
                      >
                        <VisibilityIcon color="primary" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
              {carregando && <TableRow><TableCell colSpan={6}><Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 1.5, py: 4 }}><CircularProgress /><Typography color="text.secondary">Carregando registros...</Typography></Box></TableCell></TableRow>}
              {!carregando && registrosFiltrados.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    Nenhum registro encontrado.
                  </TableCell>
                </TableRow>
              )}
              {carregando && (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    Carregando...
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Paper>
      </Box>

    </>
  );
}
